import { Box, Button, Checkbox, CircularProgress, FormControl, ListItemText, Menu, MenuItem, Select } from '@mui/material'
import dayjs from 'dayjs'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { getBranchList, getBudgetYearsList, getCatalogsList, getTypesList } from './services/api'
import { postData } from '../../services/api'
import useDebouncedResource from '../../component/useDebouncedResource'
import LoadingOverlay from '../../component/LoadingOverlay'
import { saveAs } from 'file-saver';
import api from '../../api/api'

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};
export default function ReadyForSale({ branchs, types, catalogs, budgetYears, seasons }) {
    const { profile, loading } = useSelector(state => state.profile)

    const [type, setType] = useState('all')
    const [catalog, setCatalog] = useState([])
    const [catalogNo, setCatalogNo] = useState([])
    const [season, setSeason] = useState('all')
    const [branchsNo, setBranchsNo] = useState([])
    const [branchsName, setBranchsName] = useState([])
    const [years, setYear] = useState(dayjs(new Date()).add(3, 'month').format('BBBB'))
    const { data: rawData, loading: tableLoading } = useDebouncedResource(
        () => postData('dashboard/back/ready-to-sell-items', {
            BranchNo: branchsNo,
            Season: season === 'all' ? [] : [season],
            TypeNo: type === 'all' ? [] : [type],
            CatalogNo: catalogNo,
            BudgetYear: [years],
            Month: [],
            Day: []
        }).then(res => res?.status === true ? res.result : null),
        JSON.stringify([season, type, years, branchsNo, catalogNo])
    )
    const data = rawData || []
    const [isLoading, setIsLoading] = useState(false)
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const download = async (format) => {
        const body = {
            BranchNo: branchsNo,
            Season:
                season === 'all' ? [] : [season]
            ,
            TypeNo:
                type === 'all' ? [] : [type],
            CatalogNo: catalogNo,
            BudgetYear: [years],
            Month: [],
            Day: []
        }
        setIsLoading(true)
        const res = await api.post('dashboard/back/ready-to-sell-items/' + format, body, { responseType: 'arraybuffer' })
        const data = res.data
        if (format === 'pdf') {
            const blob = new Blob([data], { type: 'application/pdf' });
            saveAs(blob, 'รายงานเมล็ดพันธุ์พร้อมจำหน่าย');

        } else {
            const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, 'รายงานเมล็ดพันธุ์พร้อมจำหน่าย');
        }
        setIsLoading(false)

    }
    const handleChange = (event) => {

        const {
            target: { value },
        } = event;

        setCatalog(
            // On autofill we get a stringified value.
            value?.length > catalogs?.length ? [] : value.filter((x) => x === 'all').length > 0 ? catalogs?.map((y) => y?.CatalogName) : value,
        );
        setCatalogNo(value?.length > catalogs?.length ? [] : value.filter((x) => x === 'all').length > 0 ? catalogs?.map((y) => y?.CatalogNo) : value.map((x) => catalogs?.find((y) => y?.CatalogName === x)?.CatalogNo));

    };
    const handleChangeBranch = (event) => {

        const {
            target: { value },
        } = event;

        setBranchsName(
            // On autofill we get a stringified value.
            value?.length > branchs?.length ? [] : value.filter((x) => x === 'all').length > 0 ? branchs?.map((y) => y?.BranchName) : value,
        );
        setBranchsNo(value?.length > branchs?.length ? [] : value.filter((x) => x === 'all').length > 0 ? branchs?.map((y) => y?.BranchNo) : value.map((x) => branchs?.find((y) => y?.BranchName === x)?.BranchNo));

    };
    return (
        <>
            <Box sx={{ display: 'flex', flexDirection: { md: "row", xs: 'column' }, justifyContent: "space-between" }}>
                <h2 className='dash-title'>เมล็ดพันธุ์ข้าวพร้อมจำหน่าย</h2>
                <Box sx={{ display: 'flex', flexDirection: { md: "row", xs: 'column' }, justifyContent: { md: "space-between", xs: 'center' }, '& .backgroundField': { background: "#a2c4e0" } }}>

                    <Box className='backgroundField' sx={{ marginRight: '20px', marginBottom: { md: '0', xs: '10px' } }}>
                        <FormControl variant="standard" fullWidth  >
                            <Select value={type}
                                onChange={e => setType(e.target.value)}
                                disableUnderline
                                MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                            >
                                <MenuItem value='all'>ชนิดข้าวทั้งหมด</MenuItem>
                                {types?.map((x, i) => (
                                    <MenuItem value={x?.TypeNo}>{x?.TypeName}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                    <Box className='backgroundField' sx={{ marginRight: '20px', marginBottom: { md: '0', xs: '10px' } }}>
                        <FormControl variant="standard" sx={{ width: 120 }} >
                            <Select value={catalog}
                                // onChange={e => setCatalog(e.target.value)}
                                multiple
                                displayEmpty
                                // value={personName}
                                onChange={handleChange}
                                renderValue={(selected) => {
                                    if (selected.length === 0) {
                                        return <>พันธุ์</>;
                                    }
                                    return selected?.join(', ')
                                }}
                                MenuProps={MenuProps}
                                disableUnderline
                            // MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                            >
                                {/* <MenuItem value='all'>พันธุ์ทั้งหมด</MenuItem>
                                {catalogs?.map((x, i) => (
                                    <MenuItem value={x?.CatalogNo}>{x?.CatalogName}</MenuItem>
                                ))} */}
                                <MenuItem value="all">
                                    <Checkbox checked={catalog?.length === catalogs?.length} />
                                    <ListItemText primary={'พันธุ์ทั้งหมด'} />
                                </MenuItem>
                                {catalogs?.map((name, i) => (
                                    <MenuItem key={i} value={name?.CatalogName}>
                                        <Checkbox checked={catalog?.indexOf(name?.CatalogName) > -1} />
                                        <ListItemText primary={name?.CatalogName} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                    <Box className='backgroundField' sx={{ marginRight: '20px', marginBottom: { md: '0', xs: '10px' } }}>
                        <FormControl variant="standard" fullWidth >
                            <Select value={season}
                                onChange={e => setSeason(e.target.value)}
                                disableUnderline
                                MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                            >
                                <MenuItem value='all'>ฤดูทั้งหมด</MenuItem>
                                {seasons?.map((x, i) => (
                                    <MenuItem value={x?.value}>{x?.value}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                    <Box className='backgroundField' sx={{ marginRight: '20px', marginBottom: { md: '0', xs: '10px' } }}>
                        <FormControl variant="standard" fullWidth >
                            <Select
                                onChange={e => setYear(e.target.value)}
                                disableUnderline
                                value={years || ''}
                                MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                            >
                                {budgetYears?.map((x, i) => (
                                    <MenuItem value={x?.BudgetYear}>{x?.BudgetYear}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                    {profile?.RoleId?.RoleId >= 10 || profile?.BranchNo?.BranchNo === '00' ?
                        <Box className='backgroundField' sx={{ marginRight: '20px', marginBottom: { md: '0', xs: '10px' } }}>
                            {/* <FormControl variant="standard" fullWidth >
                                <Select value={branchsNo}
                                    onChange={e => setBranchsNo(e.target.value)}
                                    disableUnderline
                                    MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                                >
                                    <MenuItem value='all'>ศูนย์ทั้งหมด</MenuItem>
                                    {branchs?.map((x, i) => (
                                        <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl> */}
                            <FormControl variant="standard" sx={{ width: 120 }} >
                                <Select value={branchsName}
                                    // onChange={e => setCatalog(e.target.value)}
                                    multiple
                                    displayEmpty
                                    // value={personName}
                                    onChange={handleChangeBranch}
                                    renderValue={(selected) => {
                                        if (selected.length === 0) {
                                            return <>ศูนย์</>;
                                        }
                                        return selected?.join(', ')
                                    }}
                                    MenuProps={MenuProps}
                                    disableUnderline
                                // MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                                >
                                    {/* <MenuItem value='all'>พันธุ์ทั้งหมด</MenuItem>
                                {catalogs?.map((x, i) => (
                                    <MenuItem value={x?.CatalogNo}>{x?.CatalogName}</MenuItem>
                                ))} */}
                                    <MenuItem value="all">
                                        <Checkbox checked={branchsName?.length === branchs?.length} />
                                        <ListItemText primary={'ศูนย์ทั้งหมด'} />
                                    </MenuItem>
                                    {branchs?.map((name, i) => (
                                        <MenuItem key={i} value={name?.BranchName}>
                                            <Checkbox checked={branchsName?.indexOf(name?.BranchName) > -1} />
                                            <ListItemText primary={name?.BranchName} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box> : <></>}
                    {/* <Button className='dashButton' sx={{ width: '200px', marginBottom: { md: '0', xs: '10px' } }} variant='contained' fullWidth disabled={isLoading}>
                        {isLoading ? <CircularProgress size={'24px'} color="inherit" /> : 'ดาวน์โหลด'}
                    </Button> */}
                    <Button variant='contained'
                        id="basic-button"
                        className='dashButton'
                        aria-controls={open ? 'basic-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        sx={{ width: '200px', marginBottom: { md: '0', xs: '10px', color: "#000", background: "#f7cb2d", ':hover': { background: '#f7cb2d' } } }} fullWidth disabled={isLoading}
                        onClick={handleClick}>{isLoading ? <CircularProgress size={'24px'} color="inherit" /> : 'ดาวน์โหลด'}</Button>
                    <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                        PaperProps={{
                            style: {
                                width: 200,
                            },
                        }}
                    >
                        <MenuItem onClick={() => {
                            download('xlsx')
                            handleClose()
                        }}>Excel</MenuItem>
                        <MenuItem onClick={() => {
                            download('pdf')
                            handleClose()
                        }}>Pdf</MenuItem>
                    </Menu>
                    {/* <Button style={{ width: '200px' }} variant='contained' onClick={() => getDashboard()} fullWidth disabled={isLoading}>
                  {isLoading ? <CircularProgress size={'24px'} color="inherit" /> : 'ปรับปรุงข้อมูลตามตัวกรอง'}
                </Button> */}
                </Box>
            </Box>

            <LoadingOverlay loading={tableLoading}>
            <div class="col-md-12 table-responsive-sm" style={{ height: '300px', margin: '20px 0' }}>
                <table class="table table-bordered table-hover readyForSale">
                    <thead style={{
                        background: '#fef5da',
                        color: '#382e6d',
                        position: 'sticky',
                        top: 0,
                        zIndex: 10
                    }}>
                        <tr >
                            <th scope="col " rowspan="2" class="text-center">
                                พันธุ์
                            </th>
                            <th scope="col " rowspan="2" class="text-center">ศูนย์เมล็ดพันธุ์ข้าว</th>
                            <th scope="col " colspan="3" class="text-center">ปริมาณที่จำหน่ายได้ (กิโลกรัม)</th>
                            <th scope="col " rowspan="2" class="text-center">ติดต่อ</th>
                        </tr>
                        <tr >
                            <th scope="col " class="text-center">ขยาย</th>
                            <th scope="col " class="text-center">จำหน่าย</th>
                            <th scope="col " class="text-center">รวม</th>
                        </tr>

                    </thead>
                    <tbody class="">
                        {data?.map((x) => {
                            return (
                                <tr>
                                    <td class="text-center" style={{ verticalAlign: 'middle' }}>{x?.CatalogName}</td>
                                    <td class="text-center" style={{ verticalAlign: 'middle' }}>{x?.BranchName}</td>
                                    <td class="text-center cp">
                                        {x?.BalanceClass1?.toLocaleString()}
                                    </td>
                                    <td class="text-center cp">
                                        {x?.BalanceClass2?.toLocaleString()}
                                    </td>
                                    <td class="text-center cp">
                                        {x?.Balance?.toLocaleString()}
                                    </td>
                                    <td class="text-center" style={{ verticalAlign: 'middle' }}>{x.Tel}</td>
                                </tr>
                            )
                        })}

                    </tbody>
                </table>
            </div>
            </LoadingOverlay>
        </>
    )
}
